import { Link, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useState } from "react";

const Container = styled.div`
  padding-top: 30px;
  padding-left: 24px;
  width: 195px;
  border-right: 1px solid #e3e3e3;
  display: flex;
  flex-direction: column;
  position: fixed;
  top: 160px;
  box-sizing: border-box;
  background-color: white;
  z-index: 5;
  height: calc(100vh - 160px);
  overflow-y: auto;
  overflow-x: hidden;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
`;

const BottomContainer = styled.div`
  position: absolute;
  bottom: 0;
  width: 100%;
`;

const Title = styled.span`
  font-weight: 600;
  margin-bottom: 18px;
`;

const SubTitle = styled.span`
  color: #9f9f9f;
  font-size: 14px;
  font-weight: 500;
  padding-left: 10px;
  margin-bottom: 20px;
  display: block;
  cursor: pointer;
`;

const SubTitleAccent = styled.span`
  color: #2282e9;
  font-size: 14px;
  font-weight: 500;
  padding-left: 10px;
  margin-bottom: 20px;
  display: block;
  cursor: pointer;
`;

const ModalBackground = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
`;

const ModalContainer = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  width: 22vw;
  height: 23vh;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const ModalTitle = styled.h3`
  margin-bottom: 20px;
  font-weight: 600;
  text-align: center;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 20px;
`;

const Button = styled.button`
  padding: 8px 20px;
  border-radius: 5px;
  border: none;
  font-weight: 500;
  cursor: pointer;
`;

const ConfirmButton = styled(Button)`
  background-color: #2282e9;
  color: white;
  border-radius: 50px;
`;

const CancelButton = styled(Button)`
  background-color: #e3e3e3;
  color: #333;
  border-radius: 50px;
`;

export default function SideNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  
  const handleLogoutClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setShowLogoutModal(true);
  };
  
  const handleLogoutConfirm = () => {
    // 여기에 로그아웃 로직 추가 (예: 토큰 삭제 등)
    setShowLogoutModal(false);
    sessionStorage.clear();
    navigate("/login"); // 로그인 페이지로 이동
  };
  
  return (
    <>
      <Container>
        <TitleContainer>
          <Title>홈</Title>
          <Link to="/home" style={{ textDecoration: "none" }}>
            {location.pathname === "/home" ? (
              <SubTitleAccent>메이커 홈</SubTitleAccent>
            ) : (
              <SubTitle>메이커 홈</SubTitle>
            )}
          </Link>
          <Link to="/home/company-info" style={{ textDecoration: "none" }}>
            {location.pathname === "/home/company-info" ? (
              <SubTitleAccent>게임사 정보</SubTitleAccent>
            ) : (
              <SubTitle>게임사 정보</SubTitle>
            )}
          </Link>
        </TitleContainer>
        <TitleContainer>
          <Title>플리월렛</Title>
          <Link to="/home/plimoney-charge" style={{ textDecoration: "none" }}>
            {location.pathname === "/home/plimoney-charge" ? (
              <SubTitleAccent>플리머니 충전</SubTitleAccent>
            ) : (
              <SubTitle>플리머니 충전</SubTitle>
            )}
          </Link>
        </TitleContainer>
        <TitleContainer>
          <Title>테스트 관리</Title>
          <Link to="/home/test-list/add" style={{ textDecoration: "none" }}>
            {location.pathname === "/home/test-list/add" ? (
              <SubTitleAccent>테스트 등록</SubTitleAccent>
            ) : (
              <SubTitle>테스트 등록</SubTitle>
            )}
          </Link>
          <Link to="/home/test-list" style={{ textDecoration: "none" }}>
            {location.pathname === "/home/test-list" ? (
              <SubTitleAccent>테스트 목록</SubTitleAccent>
            ) : (
              <SubTitle>테스트 목록</SubTitle>
            )}
          </Link>
        </TitleContainer>
        <TitleContainer>
          <Title>고객센터</Title>
          <Link to="/home/inquiry" style={{ textDecoration: "none" }}>
            {location.pathname === "/home/inquiry" ? (
              <SubTitleAccent>문의하기</SubTitleAccent>
            ) : (
              <SubTitle>문의하기</SubTitle>
            )}
          </Link>
          <Link to="/home/guide" style={{ textDecoration: "none" }}>
            {location.pathname === "/home/guide" ? (
              <SubTitleAccent>가이드 확인</SubTitleAccent>
            ) : (
              <SubTitle>가이드 확인</SubTitle>
            )}
          </Link>
        </TitleContainer>
        <BottomContainer>
          <SubTitle onClick={handleLogoutClick}>로그아웃</SubTitle>
        </BottomContainer>
      </Container>
      
      {showLogoutModal && (
        <ModalBackground>
          <ModalContainer>
            <ModalTitle>로그아웃</ModalTitle>
            <p>정말 로그아웃 하시겠습니까?</p>
            <ButtonContainer>
            <CancelButton onClick={() => setShowLogoutModal(false)}>아니오</CancelButton>
              <ConfirmButton onClick={handleLogoutConfirm}>예</ConfirmButton>
            </ButtonContainer>
          </ModalContainer>
        </ModalBackground>
      )}
    </>
  );
}
